import SEOHead from '@/components/base/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeatureSection from './components/FeatureSection';
import MemberBenefitsSection from './components/MemberBenefitsSection';
import LatestArticles from './components/LatestArticles';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import { siteInfo } from '@/mocks/site';
import { organizationSchema, websiteSchema } from '@/mocks/schema';

export default function Home() {
  const homeJsonLd = [
    organizationSchema,
    websiteSchema,
    {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "91网 - 官方首页",
      "url": siteInfo.url,
      "description": siteInfo.description,
      "isPartOf": {
        "@type": "WebSite",
        "name": "91网",
        "url": siteInfo.url,
      },
    },
  ];

  return (
    <>
      <SEOHead
        title="91网官方入口 - 资源整合与服务平台"
        description={siteInfo.description}
        keywords={siteInfo.keywords}
        canonicalUrl={siteInfo.url}
        ogImage="https://readdy.ai/api/search-image?query=Modern%20abstract%20geometric%20design%20with%20warm%20coral%20tones%20representing%20digital%20resource%20platform%20clean%20and%20professional%20brand%20identity&width=1200&height=630&seq=og-home-91&orientation=landscape"
        jsonLd={homeJsonLd}
      />
      <Navbar />
      <main>
        <HeroSection />
        <FeatureSection />
        <MemberBenefitsSection />
        <LatestArticles />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}